import React from 'react';
import { WeightTableProps } from '../../types/index';
import { MathMLRenderer, createMathML } from './MathMLRenderer';

const parseConditionToMathMLString = (condition: string): string => {
  const match = condition.match(/\|S_([A-Z]+)\|\s*([><=≥≤]+)\s*(\d+)/);
  
  if (match) {
    const [, variable, operator, value] = match;
    return `
      <mo>|</mo>
      <msub>
        <mi>S</mi>
        <mi>${variable}</mi>
      </msub>
      <mo>|</mo>
      <mo>${operator}</mo>
      <mn>${value}</mn>
    `;
  }
  
  return `<mtext>${condition}</mtext>`;
};

export const WeightTable: React.FC<WeightTableProps> = ({ variable, conditions }) => {
  const conditionRows = conditions.map((condition) => `
    <mtr>
      <mtd><mn>${condition.weight}</mn></mtd>
      <mtd>
        <mi>if</mi>
        <mspace width="0.222em" />
        ${parseConditionToMathMLString(condition.condition)}
        <mspace width="0.222em" />
      </mtd>
    </mtr>
  `).join('');

  const weightTableFormula = createMathML(`
    <mrow>
      <msub>
        <mi>W</mi>
        <mi>${variable}</mi>
      </msub>
      <mo>=</mo>
      <mrow>
        <mo stretchy="true" form="prefix">&#123;</mo>
        <mtable>
          ${conditionRows}
        </mtable>
      </mrow>
    </mrow>
  `);

  return <MathMLRenderer mathML={weightTableFormula} />;
};